import * as devisConf from '@/configuration/devisConf';
import calculArrondi from '@/services/calcul/calculArrondi';
import { CATEGORIE_DIVERS } from '@/configuration/catalogue/produitConf';

function majPrixUnitaireLigne(ligneCommande, pourcentageOrNewPu, typeMiseAJour) {
  const montant = calculArrondi(ligneCommande.prixUnitaire * pourcentageOrNewPu / 100);
  if (typeMiseAJour === devisConf.REMPLACEMENT_PU) ligneCommande.prixUnitaire = pourcentageOrNewPu;
  else if (typeMiseAJour === devisConf.MAJORATION) ligneCommande.prixUnitaire += montant;
  else ligneCommande.prixUnitaire -= montant;
}

export default function miseAJourPrixUnitaire(lignesCommande, pourcentageOrNewPu, typeMiseAJour) {
  lignesCommande.forEach(ligne => {
    if (ligne.type === devisConf.NORMAL) {
      majPrixUnitaireLigne(ligne, pourcentageOrNewPu, typeMiseAJour);
    }
    if (ligne.type === devisConf.REGROUPEMENT) {
      ligne.lignesCommande.forEach(ligneEnfant => {
        if (ligneEnfant.type === devisConf.NORMAL && ligneEnfant.typeProduit === CATEGORIE_DIVERS
          && ligneEnfant.produit.produitDivers && ligneEnfant.produit.produitDivers.tlpe
          && ligneEnfant.calculAutomatiqueTlpe) return;
        majPrixUnitaireLigne(ligneEnfant, pourcentageOrNewPu, typeMiseAJour);
      });
    }
  });
}
